import React, { FC } from "react";
import { toast } from "react-toastify";
import Image from "next/image";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import { Modal } from "components/atoms/Modal";
import SocialShare from "components/atoms/SocialShare";
import { ImageDTO } from "types";
import { Small, Span, SubTitle, Text } from "utils/styling/typography.styled";
import * as Styled from "./ShareModal.styled";
interface ShareModalProps {
  isOpen: boolean;
  image: ImageDTO | null;
  onClose: () => void;
}
const ShareModal: FC<ShareModalProps> = ({
  isOpen,
  image,
  onClose
}) => {
  if (!image) {
    return null;
  }
  const shareUrl = `https://char-gen.com/images/${image.id}`;
  const {
    theme,
    username,
    npcFieldsMap,
    requestType
  } = image.imageMetadata;
  const race = npcFieldsMap?.["Race"] || "";
  const characterClass = npcFieldsMap?.["Class"] || "";
  const occupation = npcFieldsMap?.["Occupation"] || "";
  const monster = npcFieldsMap?.["Monster"] || "";
  const itemName = npcFieldsMap?.["Item Name"] || "";
  const landscapeName = npcFieldsMap?.["Landscape Name"] || "";
  const itemType = npcFieldsMap?.["Item Type"] || "";
  let title = "";
  let description = "";
  switch (requestType) {
    case "LANDSCAPE":
      title = `${landscapeName} Landscape Art by ${username}`;
      description = `Theme: ${theme}`;
      break;
    case "ITEM":
      title = `${itemName} - ${itemType} Item Art by ${username}`;
      description = `Theme: ${theme}`;
      break;
    case "NPC":
      title = `NPC Art by ${username} - ${theme}`;
      description = [race, characterClass, occupation, theme].filter(Boolean).join(" ");
      break;
    case "MONSTER":
      title = `Monster Art by ${username} - ${theme}`;
      description = [monster, theme].filter(Boolean).join(" ");
      break;
    case "CHARACTER":
      title = `Character Art by ${username} - ${theme}`;
      description = [race, characterClass, occupation, theme].filter(Boolean).join(" ");
      break;
    default:
      title = `Art by ${username} - ${theme}`;
      description = theme;
  }
  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl);
    toast.success("Link Copied to Clipboard!", {
      position: "bottom-center"
    });
  };
  return <Modal open={isOpen} handleBackdropClick={onClose} disableBackdropClick data-sentry-element="Modal" data-sentry-component="ShareModal" data-sentry-source-file="index.tsx">
            <Styled.ModalContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">Share this creation</SubTitle>
                <Styled.ImageContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Image src={image.image} alt={title} width={500} height={500} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
                </Styled.ImageContainer>
                <Styled.Content data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.TextContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        <Text data-sentry-element="Text" data-sentry-source-file="index.tsx">{title}</Text>
                        <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">{shareUrl}</Small>
                    </Styled.TextContainer>
                </Styled.Content>
                <Styled.HighlightText data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    Share any image and tag CharGen to earn 1 free premium
                    token! Use @chargen_ai on Instagram and TikTok.
                </Styled.HighlightText>

                <SocialShare image={image} description={description} data-sentry-element="SocialShare" data-sentry-source-file="index.tsx" />
                <Styled.ButtonContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Button variant={ButtonType.SECONDARY} onClick={copyToClipboard} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Copy Link</Span>
                    </Button>
                    <Button type="button" variant={ButtonType.PRIMARY} onClick={onClose} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Close</Span>
                    </Button>
                </Styled.ButtonContainer>
            </Styled.ModalContainer>
        </Modal>;
};
export default ShareModal;